
import { WorldCountry } from '../../types';
import { GLOBAL_EXPANSION_CONFIG } from './expansionConfig';
import { expandCountryWithUltraCities, calculateExpansionStats, logExpansionStats } from './expansionUtils';
import { validateGlobalCoverage } from './validationUtils';

/**
 * Ejecuta la mega expansión global ultra masiva
 */
export const executeGlobalMegaExpansion = (countries: WorldCountry[]): WorldCountry[] => {
  console.log('🌟 INICIANDO MEGA EXPANSIÓN GLOBAL ULTRA MASIVA');
  console.log(`🎯 Objetivo: Cobertura COMPLETA del planeta - Municipios 50,000+ habitantes`);
  console.log(`📊 Meta total: ${GLOBAL_EXPANSION_CONFIG.totalTargetCities.toLocaleString()} ciudades globalmente`);
  console.log(`🔥 Sistema de expansión ultra masiva activado`);
  
  const expandedCountries = countries.map(country => {
    const targetCities = GLOBAL_EXPANSION_CONFIG.targetCitiesPerCountry[country.slug] || 30;
    return expandCountryWithUltraCities(country, targetCities);
  });
  
  // Calcular estadísticas finales ultra detalladas
  const finalStats = calculateExpansionStats(expandedCountries);
  
  // Mostrar estadísticas
  logExpansionStats(finalStats, GLOBAL_EXPANSION_CONFIG.totalTargetCities);
  
  return expandedCountries;
};

// Re-export everything for backward compatibility
export { validateGlobalCoverage } from './validationUtils';
export { GLOBAL_EXPANSION_CONFIG } from './expansionConfig';
export type { GlobalExpansionConfig } from './expansionConfig';
